import React from 'react'

export default function WorkTags({ data }) {
  const tags = data;

  if(!tags) {
    return null;
  }
  else return (
    <div className="flex flex-wrap gap-2">
      {tags.nodes.map(tag => (
        <span key={tag.id} className="inline-block text-black bg-orange-400 border-[2px] border-black font-bold px-2 py-1 text-[11px] shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] hover:shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[-1px] hover:translate-y-[-1px] transition-all duration-150">
          {tag.name}
        </span>
      ))}
    </div>
  );
}
